import React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import DOMPurify from 'dompurify'
import { AccessibleImage } from 'Components/accessibleImage'

interface PanoramaProps {
  panoramas?: any
  assetUrl?: string
}
const Panoramas = ({ panoramas, assetUrl }: PanoramaProps) => {
  const { locId } = useSelector((state: any) => state.location)

  return (
    <>
      {panoramas?.map((panorama: any) => {
        const descriptionPart =
          panorama.accessibility_description || panorama.description || ''
        const accessibilityText = [panorama.title, descriptionPart]
          .filter((part) => part != null && String(part).trim() !== '')
          .join('. ')
        const imageAlt =
          accessibilityText || panorama.accessibility_description || 'Panorama'
        return (
          <div
            key={
              panorama.id || panorama.hotspotMediaId || panorama.media_id
            }
          >
            <h4>{panorama.title}</h4>
            <Box
              component={'div'}
              sx={{
                width: '100%',
                maxHeight: '450px',
                background: '#f2f3f4',
                textAlign: 'center',
              }}
            >
              <AccessibleImage
                src={`${assetUrl}/media/${locId}/panoramas/${
                  panorama.id || panorama.hotspotMediaId || panorama.media_id
                }/1024.jpg`}
                alt={imageAlt}
                tooltipTitle={accessibilityText || imageAlt}
                sx={{ maxHeight: '450px', width: '100%' }}
              />
            </Box>
            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(panorama.description, {
                  ADD_ATTR: ['target'],
                }),
              }}
            />
          </div>
        )
      })}
    </>
  )
}

export default Panoramas
